

import moment from 'moment';
import UserService from '@/service/user.service.js';
const PaginatorWithPaging = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown';
const PaginatorWithoutPaging = 'RowsPerPageDropdown';

var rightNow, jan1, june1, temp, jan2, june2;
function calculate_time_zone(date) {

    var minutes;
    
    if (localStorage["TimeZone"] != null) {
        var newdate = new Date(date + 'Z');
        var TimeZone = localStorage.getItem('TimeZone')

        if (TimeZone == 'CentralEuropeanTime') { 
            formattedTime = newdate.toLocaleString("en-US", { timeZone: "Africa/Algiers" });
        }
        else if (TimeZone == 'Asia/calcutta') {
            formattedTime = newdate.toLocaleString("en-IN", { timeZone: "Asia/calcutta" });
        }
        else if (TimeZone == 'WesternEuropeanTime') {
            formattedTime = newdate.toLocaleString("en-US", { timeZone: "Atlantic/Azores" });
        }
        else if (TimeZone == 'EasternEuropeanTime') {
            formattedTime = newdate.toLocaleString("en-US", { timeZone: "Africa/Tripoli" });
        }
        else if (TimeZone == 'EasternEuropeanSummerTime') {
            formattedTime = newdate.toLocaleString("en-US", { timeZone: "Europe/Bucharest" });
        }
        else if (TimeZone == 'EasternTime') {
            formattedTime = newdate.toLocaleString("en-US", { timeZone: "America/New_York" });
        }
        else if (TimeZone == 'CentralTime') {
            formattedTime = newdate.toLocaleString("en-US", { timeZone: "America/Chicago" });
        }
        else if (TimeZone == 'Europe/Amsterdam') {
            var formattedTime = newdate.toLocaleString("en-US", { timeZone: "Europe/Amsterdam" });  
        }
        //else if (TimeZone == 'CentralEuropeanTime') {
        //    formattedTime = newdate.toLocaleString("en-US", { timeZone: "Europe/Berlin" })
        //}
        else if (TimeZone == 'CentralEuropeanSummerTime') {
            formattedTime = newdate.toLocaleString("en-US", { timeZone: "Europe/Paris" }); 
        }
        else if (TimeZone == 'WesternEuropeanSummerTime') {
            formattedTime = newdate.toLocaleString("en-US", { timeZone: "Atlantic/Canary" });
        }
        else if (TimeZone == 'FurtherEasternEuropeanTime') {
            var formattedTime = newdate.toLocaleString("en-US", { timeZone: "Africa/Djibouti" });
        }
        /*alert((new Date(usaTime)).getTimezoneOffset());*/
    //    return minutes  = convert((new Date(usaTime)).getTimezoneOffset());
        return formattedTime;
    }
    else {
        rightNow = new Date();
    }
    
    jan1 = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0);  // jan 1st
    june1 = new Date(rightNow.getFullYear(), 6, 1, 0, 0, 0, 0); // june 1st
    temp = jan1.toUTCString();
    jan2 = new Date(temp.substring(0, temp.lastIndexOf(" ") - 1));
    temp = june1.toUTCString();
    var june2 = new Date(temp.substring(0, temp.lastIndexOf(" ") - 1));
    var std_time_offset = (jan1 - jan2) / (1000 * 60 * 60);
    var daylight_time_offset = (june1 - june2) / (1000 * 60 * 60);
    var dst;
    if (std_time_offset == daylight_time_offset) {
        dst = "0"; // daylight savings time is NOT observed
    } else {
        // positive is southern, negative is northern hemisphere
        var hemisphere = daylight_time_offset - std_time_offset;
        if (hemisphere >= 0) {
            std_time_offset = daylight_time_offset;
            dst = "1"; // daylight savings time is observed
        }
    }
    var i;
    // Here set the value of hidden field to the ClientTimeZone.
    return minutes = localStorage["LocalTime"] = convert(std_time_offset);

}
var dtMonth, sDay, sYear, sHour, sMinute, sAMPM;
function formatDate(dateVal) {
    var newDate = new Date(dateVal);    
    //var sMonth = padValue(newDate.getMonth() + 1);
    dtMonth = padValue(newDate.getMonth() + 1);
    sDay = padValue(newDate.getDate());
    sYear = newDate.getFullYear();
    sHour = newDate.getHours();
    sMinute = padValue(newDate.getMinutes());

    if (isNaN(dtMonth))
        return;
    sAMPM = "AM";

    var iHourCheck = parseInt(sHour);

    if (iHourCheck > 12) {
        sAMPM = "PM";
        sHour = iHourCheck - 12;
    }
    else if (iHourCheck === 0) {
        sHour = "12";
    }

    sHour = padValue(sHour);

    switch (dtMonth) {
        case '01':
            dtMonth = '01';
            break;
        case '02':
            dtMonth = '02';
            break;
        case '03':
            dtMonth = '03';
            break;
        case '04':
            dtMonth = '04';
            break;
        case '05':
            dtMonth = '05';
            break;
        case '06':
            dtMonth = '06';
            break;
        case '07':
            dtMonth = '07';
            break;
        case '08':
            dtMonth = '08';
            break;
        case '09':
            dtMonth = '09';
            break;
        case '10':
            dtMonth = '10';
            break;
        case '11':
            dtMonth = '11';
            break;
        case '12':
            dtMonth = '12';
            break;
    }
    return dtMonth + "-" + sDay + "-" + sYear + " " + sHour + ":" + sMinute + " " + sAMPM;
}

function padValue(value) {
    return (value < 10) ? "0" + value : value;
}
// This function is to convert the timezoneoffset to Standard format
function convert(value) {

    var hours = parseInt(value);
    value -= parseInt(value);
    value *= 60;
    var mins = value;
    value -= parseInt(value);
    value *= 60;
    var secs = parseInt(value);
    var display_hours = hours.toString();
    // handle GMT case (00:00)
    if (hours == 0) {
        display_hours = "00";
    } else if (hours > 0) {
        // add a plus sign and perhaps an extra 0
        display_hours = ((hours < 10) ? "+0" + hours : "+" + hours).toString();
    } else {
        // add an extra 0 if needed
        display_hours = ((hours > -10) ? "-0" + Math.abs(hours) : hours).toString();
    }
    mins = (mins < 10) ? "0" + mins : mins;
    return display_hours + ":" + mins;
}
function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}
var timeOffSet, hourOffSet, minuteOffSet,
    minutesOffSet, preValOffSet, hoursOffSet, final;
function convertOffset(gmt_offset) {
    timeOffSet = gmt_offset.toString().split(":");
    hourOffSet = parseInt(timeOffSet[0]);
    minuteOffSet = parseInt(timeOffSet[1]);
    minutesOffSet = minuteOffSet;
    preValOffSet = hourOffSet < 0 ? "-" : "+";
    hoursOffSet = Math.abs(hourOffSet) < 10 ? "0" + Math.abs(hourOffSet) : Math.abs(hourOffSet);
    //hour = negative ? "-" + hour : "+" + hour;
    final = parseInt(hoursOffSet);
    let data = final * 60;

    return preValOffSet + parseInt(data + minutesOffSet);
}
function GetLocalTimeFromUTC(date, formatRequired) {
    var dateStringWithTime = moment(date).format('DD-MM-YYYY HH:mm:ss');
    var dateArr = dateStringWithTime.split('-');
    var val = dateArr[1] + '/' + dateArr[0] + '/' + dateArr[2];
    var dt_ = new Date(val);
    if (localStorage["LocalTime"] == null) {
        newDate_ =calculate_time_zone(dt_);
    }
    else {
        var TimeZoneHours = convertOffset(localStorage["LocalTime"]);
        let MILLISECS_PER_HOUR = TimeZoneHours /* min/hour */ * 60 /* sec/min */ * 1000 /* ms/s */;
        var newDate_ = new Date(+dt_ + MILLISECS_PER_HOUR);
       
       
    }
    if (IsNull(formatRequired) != null) {
        newDate_ = moment(newDate_).format(formatRequired);
        return newDate_
    }
    return formatDate(newDate_);
}

function formatInputDate(inputDate, outputFormat) {
    return moment(inputDate).format(outputFormat);
    if (IsNull(inputDate) == null) {
        return '';
    }
    else {
        const date = moment(inputDate).format(outputFormat); 
        const formatTokens = {
            "YYYY": date.getFullYear(),
            "MM": String(date.getMonth() + 1).padStart(2, "0"),
            "DD": String(date.getDate()).padStart(2, "0"),
            "HH": String(date.getHours()).padStart(2, "0"),
            "mm": String(date.getMinutes()).padStart(2, "0"),
            "ss": String(date.getSeconds()).padStart(2, "0"),
        };
        const formattedDate = outputFormat.replace(/(YYYY|MM|DD|HH|mm|ss)/g, token => formatTokens[token]);
        return formattedDate;
    }
    }



function IsNull(value, CheckEmptyString = true, replaceValue = null) {
    if (value != null && value != undefined && value != 'null' && value != 'undefined') {
        if (CheckEmptyString == true) {
            return value != '' ? value : replaceValue;
        }
        return value;
    }
    else {
        return replaceValue;
    }
}
import dynamicUiText from './dynamicUiText';
import { terminologyRevision } from './terminologyReactive';

function dynamicTranslate(value, key , replaceValue) {
    void terminologyRevision.value;
    if (value != key) {
        return value;
    }
    return dynamicUiText.applyDynamicTerminology(replaceValue);
}

function uiText(value) {
    void terminologyRevision.value;
    return dynamicUiText.applyDynamicTerminology(value);
}

function dateFormat(date, format = null) {
    if (IsNull(date) == null) {
        return '';
    }
    const ddate =  Date.parse(date);
    return GetLocalTimeFromUTC(ddate, format);
}


function TruncateStr(str, len) {
    var convertstring = '' + str;
    if (convertstring != null)
        if (convertstring.length <= len) return str;
        else return convertstring.substring(0, len) + "...";
}

function PaginatorTemplate(totalRecords, pageSize) {
    let paginatorTemplate = { default: PaginatorWithPaging }

    if ((totalRecords / pageSize) > 1) {
        paginatorTemplate.default = PaginatorWithPaging;
    }
    else {
        paginatorTemplate.default = PaginatorWithoutPaging;
    }

    return paginatorTemplate
}

function FirstAndLastNameAlpha(firstName, LastName) {
    let result = '';
    if (IsNull(firstName) != null && IsNull(LastName) != null) {
        result = firstName.substr(0, 1).concat(LastName.substr(0, 1)).toUpperCase();
        return result;
    }
    if (IsNull(firstName) != null && IsNull(LastName) == null) {
        result = firstName.substr(0, 2).toUpperCase();
        return result;
    }
    return 'ZU'
}

function convertDecimalValueInFormat(value) {
    try {
        value = parseFloat(value, 10);
        value = value.toFixed(2);
        value = parseFloat(value, 10);
        value = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return value;
    } catch (ex) {
        return value
    }
}
async function GetPageSizeList(val) {

    await UserService.GetPageSizeList().then( response => {
        if (IsNull(response.data) != null) {
            val.pageSizeList = response.data.map(item => {
                console.log('parseInt(item.text)', parseInt(item.text))
                return parseInt(item.text)
            });
        }
    }).catch((error) => {
        console.log('pageSizeList Error', error);
    });
}
//function ConvertUSCurrency(value) {

//    if (IsNull(value, true, null) != null) {


//        if (localStorage.getItem('currency') == 'USD') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
//            return formatCurrency.format(CurrencyValue);
//        }
//        else if (localStorage.getItem('currency') == 'PoundSterling') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' })
//            return formatCurrency.format(CurrencyValue);
//        }
//        else if (localStorage.getItem('currency') == 'EUR') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('en-DE', { style: 'currency', currency: 'EUR' })
//            return formatCurrency.format(CurrencyValue);
//        }
//        else if (localStorage.getItem('currency') == 'INR') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' })
//            return formatCurrency.format(CurrencyValue);
//        }
//        else if (localStorage.getItem('currency') == 'BulgarianLev') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('bg-BG', { style: 'currency', currency: 'BGN' })
//            return formatCurrency.format(CurrencyValue);
//        }
//        else if (localStorage.getItem('currency') == 'PolishZloty') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('PLN', { style: 'currency', currency: 'PLN' })
//            return formatCurrency.format(CurrencyValue);
//        }
//        else if (localStorage.getItem('currency') == 'BosniaandHerzegovinaConvertibleMark') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('bs-BA', { style: 'currency', currency: 'BAM' })
//            return formatCurrency.format(CurrencyValue);
//        }
//        else if (localStorage.getItem('currency') == 'DanishKrone') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' })
//            return formatCurrency.format(CurrencyValue);
//        }
//        else if (localStorage.getItem('currency') == 'SwissFranc') {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('fr-CH', { style: 'currency', currency: 'CHF' })
//            return formatCurrency.format(CurrencyValue);
//        }

//        else {
//            let CurrencyValue = parseInt(value)
//            const formatCurrency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
//            return formatCurrency.format(CurrencyValue);
//        }

//    }
//}


function ConvertUSCurrency(value) {

    // Handle null, undefined, or empty string
    if (value === null || value === undefined || value === '') {
        value = 0;
    }

    let CurrencyValue = parseFloat(value);
    if (isNaN(CurrencyValue)) {
        CurrencyValue = 0;
    }

    if (localStorage.getItem('currency') == 'USD') {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(CurrencyValue);
    }
    else if (localStorage.getItem('currency') == 'PoundSterling') {
        return new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP'
        }).format(CurrencyValue);
    }
    else if (localStorage.getItem('currency') == 'EUR') {
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
        }).format(CurrencyValue);
    }
    else if (localStorage.getItem('currency') == 'INR') {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(CurrencyValue);
    }
    else if (localStorage.getItem('currency') == 'BulgarianLev') {
        return new Intl.NumberFormat('bg-BG', {
            style: 'currency',
            currency: 'BGN'
        }).format(CurrencyValue);
    }
    else if (localStorage.getItem('currency') == 'PolishZloty') {
        return new Intl.NumberFormat('pl-PL', {
            style: 'currency',
            currency: 'PLN'
        }).format(CurrencyValue);
    }
    else if (localStorage.getItem('currency') == 'BosniaandHerzegovinaConvertibleMark') {
        return new Intl.NumberFormat('bs-BA', {
            style: 'currency',
            currency: 'BAM'
        }).format(CurrencyValue);
    }
    else if (localStorage.getItem('currency') == 'DanishKrone') {
        return new Intl.NumberFormat('da-DK', {
            style: 'currency',
            currency: 'DKK'
        }).format(CurrencyValue);
    }
    else if (localStorage.getItem('currency') == 'SwissFranc') {
        return new Intl.NumberFormat('fr-CH', {
            style: 'currency',
            currency: 'CHF'
        }).format(CurrencyValue);
    }
    else {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(CurrencyValue);
    }
}
function onlyDate(date) {
    if (IsNull(date) != null) {
        var format = new Date(date);
        var value = format.getFullYear() + "-" + ((format.getMonth() + 1) > 9 ? '' : '0')
            + (format.getMonth() + 1) + "-" + (format.getDate() > 9 ? '' : '0') + format.getDate();
        return value;
    }
    return null
}
// utils/formatAmount.js
 function formatUSAmount(value) {
    if (value === null || value === undefined || value === '') return '';

    const num = parseFloat(value);
    if (isNaN(num)) return '';

    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(num);
}

 function parseUSAmount(formattedValue) {
    if (!formattedValue) return null;
    // Remove commas before parsing back to number
    return parseFloat(formattedValue.replace(/,/g, ''));
}
export default {
    IsNull,
    dynamicTranslate,
    uiText,
    PaginatorTemplate,
    dateFormat,
    TruncateStr,
    FirstAndLastNameAlpha,
    convertDecimalValueInFormat,
    GetPageSizeList,
    formatInputDate,
    ConvertUSCurrency,
    calculate_time_zone,
    onlyDate, formatAMPM, formatUSAmount, parseUSAmount
};